/**
 * Feature Flags
 *
 * Runtime feature flags derived from the validated environment.
 */

import { env } from './env';

// Build-time flags. Only darkMode is consumed at build level (ThemeProvider
// availability); the rest are RUNTIME settings served via /api/config/public
// (features.* keys) and consumed with useFeatureEnabled.
export const features = {
  darkMode: env.VITE_ENABLE_DARK_MODE,
} as const;
